import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EpisodeType {
	travrvNo: string;
	title: string;
	custNm: string;
	regDt: string;
	bestYn: string;
	reportYn: string;
	contents: string;
}

/** ```
 * 여행 후기 상세 조회
 *   `/pkg/review/by-goods/{goodsCd}/episode`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const key = "useReviewEpisode";
const getPath = (goodsCd: string): string | null => {
	if (!goodsCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/review/by-goods/${goodsCd}/episode`;
};

/** ```
 * 여행 후기 상세 조회
 *   `/pkg/review/by-goods/{goodsCd}/episode`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useReviewEpisode = (goodsCd: string, options?: Partial<UseQueryOptions<Response<EpisodeType[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useReviewEpisode;
export {getPath, key};
export type {EpisodeType};
